import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useTitle } from "react-use";
import Reaptcha from "reaptcha";
import dueLogo from "../../assets/images/logo.svg";
import Button from "../../components/Button";
import { FormField } from "../../components/forms/shared";
import TextInput from "../../components/forms/TextInput";
import { RECAPTCHA_SITE_KEY } from "../../config";
import { ROUTE_LOGIN } from "../../routes";
import { forgotPassword } from "../../services/user";

const ForgotPassword = () => {
  useTitle("Forgot Password | Due");
  const [disabled, setDisable] = useState(false);
  const [captchaToken, setCaptchaToken] = useState("");
  const [email, setEmail] = useState("");
  const captchaRef = useRef<Reaptcha>(null);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const requestForgotPassword = () => {
    setDisable(true);
    forgotPassword(email, captchaToken).subscribe(
      () => {
        setTimeout(() => {
          setDisable(false);
          captchaRef.current?.reset();
        }, 10000);
        setMessage("Reset password instructions has been sent to your email.");
      },
      () => {
        setDisable(false);
        captchaRef.current?.reset();
        setError("Failed to reset password please contact support.");
      }
    );
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <Link to={ROUTE_LOGIN}>
          <img className="mx-auto h-10 w-auto" src={dueLogo} alt="Due" />
        </Link>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Forgot Password
        </h2>
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <p className="text-sm mb-4">
            We will send you an email with instructions on how to reset your
            password.
          </p>

          {message && (
            <div className="mb-4">
              <div className="text-sm text-gray-600">{message}</div>
              <Link
                to={ROUTE_LOGIN}
                className="text-sm text-green-600 font-semibold"
              >
                Return to login
              </Link>
            </div>
          )}
          {error && <div className="text-sm text-red-500 mb-4">{error}</div>}
          <FormField label="Email">
            <TextInput
              type="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
          </FormField>
          <Reaptcha
            ref={captchaRef}
            size="normal"
            sitekey={RECAPTCHA_SITE_KEY}
            onLoad={() => {}}
            onVerify={(recaptchaResponse) => {
              setCaptchaToken(recaptchaResponse);
              console.log(recaptchaResponse);
            }}
            onExpire={() => {
              captchaRef.current?.reset();
            }}
            onError={() => {
              captchaRef.current?.reset();
            }}
          />
          <Button
            className="mt-6"
            disabled={disabled || !captchaToken}
            onClick={() => {
              requestForgotPassword();
            }}
          >
            Reset Password
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
